import { httpApi } from "./http.api";
interface Candidate {
  candidates: number[];
  tags: string[];
  job_name?: string;
  job_id?: string;
  select_all?: boolean;
  project_id: any;
}
// Get a list of projects
export const getProjects = (search = "", page = 1) => {
  return httpApi.get(`/ats/job?search=${search}&page=${page}`).then((data) => data.data);
};
// Get a list of tags
export const getTags = (search = "", page = 1) => {
  return httpApi.get(`/ats/tag/?search=${search}&page=${page}`).then((data) => data.data);
};
// Send candidates
export const sendCandidates = (templateData: Candidate) => {
  return httpApi.post("/ats/create-candidate/", templateData).then((data) => data.data);
};
